module.exports = __webpack_public_path__ + "static/media/grill-1.1a9a681a.jpg";